export default "__VITE_ASSET__9cc232f4__"